import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Authentication from '../../../../../libs/api/services/Authentication'
import Patient from '../../../../../libs/api/services/Patient'
import StickyNavigationContext from '../../../../../libs/providers/StickyNavigationProvider'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import PatientManagementDetailsComponent from '../PatientManagementDetailsComponent'
import PatientContext from '../PatientProvider'

export default function PatientProfileContainer({ permissions, isOwn, onSaved, setProfile, category, profile }) {
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [layout, setLayout] = useState([])
    const { setSectionInfo } = useContext(CommonFunctionsContext)
    const { activePatient, SetActivePatient } = useContext(PatientContext)
    const navigate = useNavigate()

    const [version, setVersion] = useState(0)
    const { setSticky, setPreventMessage, setPreventMessageAsync } = useContext(StickyNavigationContext)
    const { showToast, showError } = useContext(CommonFunctionsContext)


    useEffect(() => {

        const _loadFields = () => {
            setLoading(true)
            Patient.LoadFields(category.id, isOwn)
                .then((r) => {
                    _renderComonents(r)
                })
        }
        _loadFields()
    }, [category])


    useEffect(() => {
        if (activePatient)
            setSectionInfo(`Managing patient ${activePatient.userProfile.firstName} ${activePatient.userProfile.lastName} at ${Authentication.getFacilityName()}`);
        else {
            setVersion(3)
            // setSticky(true)
            setPreventMessageAsync('Unsaved Changes', 'You have unsaved changes. <br/>Would you like to save them?', async () => { await _handleSave() }, async () => window.location = '/Dashboard')
            setSectionInfo(`Managing a new patient at ${Authentication.getFacilityName()}`);
        }
        return () => { setSectionInfo(undefined) }
    }, [activePatient])

    useEffect(() => {
        if (version !== 0) {
            if (version !== 3) {
                setPreventMessage('Unsaved Changes', 'You have unsaved changes. <br/>Would you like to save them?', () => _handleSave(), "Discard")
                onbeforeunload = (event) => { event.preventDefault(); return false; }
                setSticky(true)
            } else {
                // setSticky(false)
                // onbeforeunload = (event) => { return }
            }

        } else {
            setSticky(false)
            onbeforeunload = (event) => { return }
        }
    }, [version])

    const _handleSetValue = (i, v) => {
        setVersion(2)
        var _profile = { ...profile }
        var _detail = _profile.profiles.find(p => p.detailsType.id === i)
        if (!_detail) {
            _profile.profiles.push({ detailsType: { id: i }, detail: v })
        } else {
            // Update
            _detail.detail = v
        }
        setProfile({ ..._profile })
    }
    const _reloadProfile = async (newProfileId, redir) => {
        if (!profile.id) {
            onbeforeunload = (event) => { event.preventDefault(); return false; };
            if (!onSaved) navigate('/Dashboard/Patient/' + newProfileId)
        } else
            setProfile(await Patient.LoadPatient(newProfileId))
    }

    const _handleSave = async (redir) => {
        setSaving(true)
        showToast('Saving changes', undefined, 3)
        var _profile = profile

        if (!_profile.id) {
            _profile = await Patient.InitNewPatient(Authentication.getFacility())
        }

        var details = []
        for (var d in profile.profiles) {
            details.push(
                {
                    Detail: profile.profiles[d].detail,
                    DetailsType: {
                        Id: profile.profiles[d].detailsType.id
                    }
                }
            )
            // await Patient.SetPatientProfileDetail(profile.profiles[d].detailsType.id, profile.profiles[d].detail, _profile.id)
        }
        // console.log('_handleSave 2', details)
        if (await Patient.SetPatientProfileDetailBulk(details, _profile.id).catch((e) => showError(e))) {
            // console.log('_handleSave 3')
            SetActivePatient(_profile.id)
            if (onSaved) onSaved(_profile)
            setVersion(0)
            setSticky(false)
            onbeforeunload = (event) => { return }
            _reloadProfile(_profile.id, redir)
            showToast('Profile changes saved', undefined, 3)

        }
        setSaving(false)
    }

    var row_cntr = 0;
    const _handleLayoutSize = async (_id, options) => {
        const _layout = options.find(f => f.category === 'Layout')
        if (typeof _layout !== 'undefined') {
            const _grid = _layout.options.find(f => f.option === 'Grid')
            if (typeof _grid !== 'undefined') {
                const r = await Patient
                    .FieldTypesOptionsDefaults(_id, _grid.id)
                if (r && r.length > 0) {
                    if (r[0].value && r[0].value.length > 0) {
                        var cols = JSON.parse(r[0].value[0].property)
                        row_cntr += cols.lg;
                        if (row_cntr > 12)
                            row_cntr = 0;
                        return 'col-lg-' + cols.lg + ' col-md-' + cols.md + ' col-sm-' + cols.sm + ' '
                    }
                }
                else {
                    row_cntr = 0
                }
            } else {
                row_cntr = 0
            }
        } else {
            row_cntr = 0
        }
        return 'col-lg-12 col-md-12 col-sm-12 '
    }

    const _renderComonents = async (fields) => {
        var ret_r = []
        var ret_c = []
        if (fields) {
            // for (var i = 0; i < Object.keys(fields).length; i++) {
            for (const field of fields) {
                const resource = field && field.resource ? field.resource : undefined
                if (!resource) continue
                //permissions
                // console.log(fields[i])
                // const _permission = permissions.find(a => a.field.id == fields[i].id)
                // const _can_edit = permissions.find(a => a.field.id == fields[i].id && a.accessType === 'Edit')
                // if (!_permission) continue;

                const lo = await _handleLayoutSize(resource.id, resource.type.patientProfileDetailTypeOptions)
                if (row_cntr === 0) {
                    ret_r.push(<div className='row'>{ret_c}</div>)
                    ret_c = []
                }
                ret_c.push(
                    <div key={resource.id} className={lo}>
                        {
                            <PatientManagementDetailsComponent
                                id={resource.id}
                                canEdit={field.accessTypes.includes('Edit')}
                                value={resource.value}
                                type={resource.type.type}
                                options={resource.type.patientProfileDetailTypeOptions}
                                profile={profile}
                                onChanged={(prop, val) => _handleSetValue(prop, val)}
                            />
                        }

                    </div>
                )
            }
            ret_r.push(<div className='row'>{ret_c}</div>)
        }
        setLoading(false)
        setLayout(ret_r);
    }
    // if (loading) return <div className='h-100 w-100 d-flex align-items-center justify-content-center'><div><FontAwesomeIcon icon={faSpinner} spin /> Loading Patient Details</div></div>
    if (loading) return <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'>
        <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
        <b className='p-3'>Loading Patient Details</b>
    </div>
    return (
        <>
            {/* <div className='flex-grow-1 p-2' style={{ overflow: 'auto' }}> */}
            <form
                autoComplete="off"
                onKeyUp={(e) => {
                    if (e.code === 'Enter') _handleSave()
                }}
            >
                <input type="hidden" value={new Date().toISOString()} />
                {layout.map((l) => l)}
            </form>
            {/* </div> */}
            <div className=' w-100 text-center p-3' style={{ position: 'sticky', bottom: '0px' }}>
                {!saving ? <button
                    type='submit'
                    onClick={() => _handleSave()}
                    className='btn bg-primary-container'>Save</button>
                    : <div><FontAwesomeIcon icon={faSpinner} spin /> Saving</div>}
            </div>
        </>
    )
}
